import * as React from "react";
import { ArrowClockwise20Regular } from "@fluentui/react-icons";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { MY_PACKAGES_AGREEMENTS_KEY, MY_PACKAGES_PRODUCTS_KEY, MY_PACKAGES_WORKS_KEY } from "../../../Consts";
import MyPackagesGeneralDataView from "../MyPackagesGeneralDataView/MyPackagesGeneralDataView";
import MyPackagesGridView from "../MyPackagesGridView/MyPackagesGridView";
import { IMyPackagesDetails } from "../../../types/IMyPackagesDetails";
import { EntityType } from "../../../types/EntityType";
import { IMyPackagesDownloadFileFormat } from "../../../types/IMyPackagesDownloadFileFormat";
import { IPackageDataItem } from "../../../types/IPackageDataItem";
import moment from "moment";
import { MEMBERS_PORTAL } from "../../../../accounts/Consts";
import ScrollEventListenerWrapperContainerDetailsWindow from "../../../../dataingestion/components/containerDetailsWindow/ScrollEventListenerWrapperContainerDetailsWindow";
import { addFileToUpload, CleanUploadFilesState, setInDropZone, setProgressUploadFileProccess } from "../../../../redux/reducers/DataIngestionReducer";
import { IFileSystem } from "../../../../dataingestion/types/IFileSystem";
import { ITreeNodeData } from "../../../../treeview/types/TreeNodeData";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { ITreeData } from "../../../types/ITreeData";
import { UPLOAD_BULK_WORKS_PAGE_VIEW, UPLOAD_CUE_SHEETS_PAGE_VIEW } from "../../../../membersportal/Consts";
import { IAttachedFile } from "../../../../redux/types/IAttachedFile";
import { DataSource } from "../../../types/DataSource";
import IDroppedFiles from "../../../../redux/types/IDroppedFiles";
import { MessageBanner, MessageType } from "../../../components/messageBanner/MessageBanner";

export interface MyPackagesMaintenanceProps {
    packageMaintenanceGridsViewData: IRepertoireComponentDataItem;
    myPackagesGeneralDataViewData: IRepertoireComponentDataItem;
    searchResultsTableData?: IRepertoireComponentDataItem;
    componentInstance: string;
    tabs: ITabReduxItem[];
    activeTab: number;
    isReadonly: boolean;
    lookupValues: ILookupDictionary;
    activeHeaderSection?: string;
    title: string;
    downloadFileFormat?: IMyPackagesDownloadFileFormat;
    getMyPackagesDetails?: (userName: string, modalOpen: boolean) => void;
    currentUser?: string;
    myPackagesGridView?: IRepertoireComponentDataItem;
    myPackagesResult?: IMyPackagesDetails[];
    getDownloadFileFormat?: () => void;
    clearPackages?: (myPackages: IMyPackagesDetails) => void;
    generatePackage?: (myPackage: IMyPackagesDetails) => void;
    closePackage?: (myPackage: IMyPackagesDetails) => void;
    addPackageNote?: (myPackage: IMyPackagesDetails) => void;
    portalType?: string;
    alertMessage: string;
    containerDetailsWindowComponentData?: IComponentDataItem;
    storagePathItemData: IComponentDataItem;
    destinations?: ILookupInstance[];
    droppedFiles?: any;
    isDropZone?: boolean;
    selectedFileSystem?: IFileSystem;
    treeNodes: ITreeNodeData<IFileSystem>[];
    getDataIngestionComponentData?: (componentName: string, componentInstance: string) => void;
    addFileToUpload: typeof addFileToUpload;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    setInDropZone?: typeof setInDropZone;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    refreshDirectory?: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    removeAttachmentIfExists?: (attachedFile: IAttachedFile, source: DataSource) => void;
    filesDropped?: IDroppedFiles;
    isPackageSaved?: boolean;
    packageDetails?: IMyPackagesDetails;
    fullCataloguePackagePending?: boolean;
    packageOperationInProgress?: boolean;
}

interface MyPackagesMaintenanceState {
    activeHeaderSection: string;
    loaded: boolean;
    roleOptions: ILookupInstance[];
    role: any;
    DownloadFileFormats: string[];
    myPackagesGridViewData: any[];
    lastModifiedDate: Date;
    packageItemsCount: number;
    entityType: EntityType;
    resetBanner?: boolean;
    showAlertMessage: boolean;
}

export default class MyPackagesMaintenancePage extends React.PureComponent<
    MyPackagesMaintenanceProps,
    MyPackagesMaintenanceState
> {
    viewData;

    private getPackageFormats = (sectionData?: IPackageDataItem): string[] => {
        const { portalType } = this.props;

        if (portalType === MEMBERS_PORTAL) {
            return sectionData?.PortalFileFormats ?? [];
        }

        return sectionData?.DownloadFileFormats ?? [];
    }

    constructor(props: MyPackagesMaintenanceProps) {
        super(props);

        this.state = {
            activeHeaderSection: props.activeHeaderSection ?? "Works",
            loaded: false,
            roleOptions: [],
            role: '',
            DownloadFileFormats: [],
            myPackagesGridViewData: [],
            lastModifiedDate: null,
            packageItemsCount: 0,
            entityType: EntityType.Work,
            resetBanner: false,
            showAlertMessage: !!props.alertMessage
        }
        this.viewData = {};
    }

    componentDidMount() {

        const { downloadFileFormat, myPackagesResult } = this.props;

        if (myPackagesResult) {
            const intialGridData = this.getInitialmyPackagesGridViewData(EntityType.Work, myPackagesResult);
            this.setState({ myPackagesGridViewData: intialGridData });
        }
        if (downloadFileFormat?.[EntityType.Work]) {
            const sectionData = downloadFileFormat[EntityType.Work];
            this.setState({ DownloadFileFormats: this.getPackageFormats(sectionData) });
        }
    }

    componentDidUpdate(prevProps: MyPackagesMaintenanceProps) {

        const { myPackagesResult, downloadFileFormat, isPackageSaved, alertMessage } = this.props;
        const { entityType } = this.state;

        if (myPackagesResult !== prevProps.myPackagesResult || downloadFileFormat !== prevProps.downloadFileFormat) {
            if (myPackagesResult) {
                const intialGridData = this.getInitialmyPackagesGridViewData(entityType, myPackagesResult);
                this.setState({ myPackagesGridViewData: intialGridData });
            }
            if (downloadFileFormat?.[entityType]) {
                const sectionData = downloadFileFormat[entityType];
                this.setState({ DownloadFileFormats: this.getPackageFormats(sectionData) });
            }
        }
        if (isPackageSaved !== prevProps.isPackageSaved) {
            this.setState({ resetBanner: isPackageSaved })
        }

        if (alertMessage !== prevProps.alertMessage) {
            this.setState({ showAlertMessage: !!alertMessage })
        }
    }

    getInitialmyPackagesGridViewData(defaultSection: string, myPackagesResult?: IMyPackagesDetails[] | { data?: IMyPackagesDetails[] }) {
        const packages = Array.isArray(myPackagesResult)
            ? myPackagesResult
            : Array.isArray(myPackagesResult?.data)
                ? myPackagesResult.data
                : [];

        if (packages.length > 0) {
            return packages.filter(x => x.entityType === defaultSection);
        }
    }

    handleClearPackages = (updatedPackagesData: IMyPackagesDetails[], headerType?: string) => {

        const clearedGridData = updatedPackagesData.filter(packageItem => packageItem.entityType === headerType);
        this.setState({
            myPackagesGridViewData: clearedGridData,
        });
    };

    onClickHeaderSection = (activeHeaderSection: { name: string }) => {
        const selectedHeaderSection: string = activeHeaderSection.name;
        const { downloadFileFormat, myPackagesResult } = this.props;
        const sectionData = downloadFileFormat?.[selectedHeaderSection];
        const intialGridData = this.getInitialmyPackagesGridViewData(selectedHeaderSection, myPackagesResult);
        this.setState({
            activeHeaderSection: selectedHeaderSection,
            DownloadFileFormats: this.getPackageFormats(sectionData),
            myPackagesGridViewData: intialGridData,
            entityType: selectedHeaderSection as EntityType,
        });
    };



    renderGridViewHeaderSections = () => {
        const { activeHeaderSection } = this.state;
        const { myPackagesGeneralDataViewData, portalType } = this.props;

        if (!myPackagesGeneralDataViewData?.fields) {
            return null;
        }

        const allowedEntityTypes =
            portalType === MEMBERS_PORTAL
                ? [EntityType.Work, EntityType.Products]
                : [
                    EntityType.Work,
                    EntityType.Products,
                    EntityType.Agreements
                ];

        return myPackagesGeneralDataViewData.fields
            .filter(field =>
                field.fieldType === null &&
                allowedEntityTypes.includes(field.name as EntityType)
            )
            .map((section, index) => (
                <div
                    className={[
                        "headerSection",
                        activeHeaderSection === section.name
                            ? "activeSection"
                            : null
                    ].filter(Boolean).join(" ")}
                    key={index}
                    onClick={() =>
                        this.onClickHeaderSection(section)
                    }
                >
                    {section.data}
                </div>
            ));
    };

    onClickRefresh = () => {
        const { currentUser, getMyPackagesDetails } = this.props;
        getMyPackagesDetails(currentUser, true);
    };

    resetMessage = () => {
        this.setState({ resetBanner: false });
    }

    resetAlertMessage = () => {
        this.setState({ showAlertMessage: false });
    }

    render() {
        const {
            myPackagesGeneralDataViewData,
            getMyPackagesDetails,
            myPackagesGridView,
            myPackagesResult,
            clearPackages,
            downloadFileFormat,
            generatePackage,
            closePackage,
            addPackageNote,
            alertMessage,
            containerDetailsWindowComponentData,
            storagePathItemData,
            destinations,
            droppedFiles,
            isDropZone,
            selectedFileSystem,
            treeNodes,
            getDataIngestionComponentData,
            addFileToUpload,
            cleanUploadFilesState,
            setInDropZone,
            setProgressUploadFileProccess,
            refreshDirectory,
            addRepertoireAttachmentToState,
            removeAttachmentIfExists,
            filesDropped,
            portalType,
            fullCataloguePackagePending
        } = this.props;
        const { activeHeaderSection, DownloadFileFormats, myPackagesGridViewData, lastModifiedDate, packageItemsCount } = this.state;
        const username = this.props.currentUser;
        const formattedContents = (myPackagesGridViewData || []).map(item => ({
            lastModifiedDate: moment(item.lastModifiedDate).format("DD/MM/YYYY hh:mm A"),
            note: item.note,
            id: item.id,
            downloadFileFormat: item.downloadFileFormat,
            PackageItems: item.PackageItems,
            status: item.status,
            username: item.username,
            entityType: item.entityType,
            downloadLink: item.downloadLink,
        }));

        return (
            <>
                <div>
                    <div className="GridsView">
                        <div className="row" style={{ marginBottom: "15px" }}>
                            <div className="col-md-12 editableSectionHeading">

                                <div><span className="title">{myPackagesGeneralDataViewData.fields.find(f => f.name.toString() === activeHeaderSection)?.data}</span></div>

                                <button className="refreshBtn" title="Refresh myPackage details" onClick={() => this.onClickRefresh()}>
                                    <ArrowClockwise20Regular className="icon" aria-hidden="true" />
                                </button>

                            </div>
                        </div>

                        {alertMessage && this.state.showAlertMessage && <div className="row"><MessageBanner resetMessageBanner={() => this.resetAlertMessage()} messageType={MessageType.Warning} messages={[myPackagesGeneralDataViewData.fields.find(f => f.name.toString() === alertMessage)?.data || alertMessage]} /></div>}
                        {this.state.resetBanner && <div className="row">
                            <MessageBanner resetMessageBanner={() => this.resetMessage()} messageType={MessageType.Success} messages={[myPackagesGeneralDataViewData.fields.find(f => f.name.toString() === 'packageGenerationSuccessMessage')?.data]} />
                        </div>}

                        <div className="headerContainer">
                            {this.renderGridViewHeaderSections()}
                        </div>

                        {activeHeaderSection === MY_PACKAGES_WORKS_KEY ?
                            <>


                                <MyPackagesGeneralDataView
                                    myPackagesGeneralDataViewData={myPackagesGeneralDataViewData}
                                    isReadonly={false}
                                    clearPackages={clearPackages}
                                    lookupValues={undefined}
                                    DownloadFileFormats={DownloadFileFormats}
                                    myPackagesResult={myPackagesResult}
                                    getMyPackagesDetails={getMyPackagesDetails}
                                    currentUser={username}
                                    headerType={EntityType.Work}
                                    handleClearPackages={this.handleClearPackages}
                                    editableFields={[]}
                                    generatePackage={generatePackage}
                                    closePackage={closePackage}
                                    addPackageNote={addPackageNote}
                                    savePackages={undefined}
                                    containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                                    storagePathItemData={storagePathItemData}
                                    destinations={destinations}
                                    droppedFiles={droppedFiles}
                                    isDropZone={isDropZone}
                                    selectedFileSystem={selectedFileSystem}
                                    treeNodes={treeNodes}
                                    getDataIngestionComponentData={getDataIngestionComponentData}
                                    addFileToUpload={addFileToUpload}
                                    cleanUploadFilesState={cleanUploadFilesState}
                                    setInDropZone={setInDropZone}
                                    setProgressUploadFileProccess={setProgressUploadFileProccess}
                                    refreshDirectory={(filesystem, sources) => refreshDirectory(filesystem, sources)}
                                    addRepertoireAttachmentToState={(attachedFile) => addRepertoireAttachmentToState(attachedFile)}
                                    removeAttachmentIfExists={removeAttachmentIfExists}
                                    filesDropped={filesDropped}
                                    portalType={portalType}
                                    fullCataloguePackagePending={fullCataloguePackagePending}
                                    packageOperationInProgress={this.props.packageOperationInProgress}
                                />
                                <div>
                                    {formattedContents.length > 0 &&
                                        <MyPackagesGridView
                                            currentUser={username}
                                            getMyPackagesDetails={getMyPackagesDetails}
                                            componentInstance={""}
                                            myPackagesGridView={myPackagesGridView}
                                            tableContents={formattedContents}
                                        />
                                    }

                                </div>

                            </> : <div> </div>}

                        {activeHeaderSection === MY_PACKAGES_PRODUCTS_KEY ? <>


                            <MyPackagesGeneralDataView
                                myPackagesGeneralDataViewData={myPackagesGeneralDataViewData}
                                clearPackages={clearPackages}
                                isReadonly={false}
                                lookupValues={undefined}
                                DownloadFileFormats={DownloadFileFormats}
                                myPackagesResult={myPackagesResult}
                                headerType={EntityType.Products}
                                getMyPackagesDetails={getMyPackagesDetails}
                                currentUser={username}
                                handleClearPackages={this.handleClearPackages}
                                editableFields={[]}
                                generatePackage={generatePackage}
                                closePackage={closePackage}
                                addPackageNote={addPackageNote}
                                portalType={portalType}
                                fullCataloguePackagePending={fullCataloguePackagePending}
                                packageOperationInProgress={this.props.packageOperationInProgress}
                            />
                            <div>
                                <MyPackagesGridView
                                    currentUser={username}
                                    getMyPackagesDetails={getMyPackagesDetails}
                                    componentInstance={""}
                                    myPackagesGridView={myPackagesGridView}
                                    tableContents={formattedContents}
                                />
                            </div>

                        </> : <div> </div>}

                        {activeHeaderSection === MY_PACKAGES_AGREEMENTS_KEY ?
                            <>


                                <MyPackagesGeneralDataView
                                    myPackagesGeneralDataViewData={myPackagesGeneralDataViewData}
                                    isReadonly={false}
                                    clearPackages={clearPackages}
                                    lookupValues={undefined}
                                    DownloadFileFormats={DownloadFileFormats}
                                    myPackagesResult={myPackagesResult}
                                    headerType={EntityType.Agreements}
                                    getMyPackagesDetails={getMyPackagesDetails}
                                    currentUser={username}
                                    handleClearPackages={this.handleClearPackages}
                                    editableFields={[]}
                                    generatePackage={generatePackage}
                                    closePackage={closePackage}
                                    addPackageNote={addPackageNote} />
                                <div>
                                    <MyPackagesGridView
                                        currentUser={username}
                                        getMyPackagesDetails={getMyPackagesDetails}
                                        componentInstance={""}
                                        myPackagesGridView={myPackagesGridView}
                                        tableContents={formattedContents}
                                    />
                                </div>

                            </> : <div> </div>}
                    </div>
                </div>

            </>
        );
    }
}